import { cn } from '@/lib/cn';
import { buttonVariants } from '@heidi/design-system/button';

/**
 * Row classes shared by the secondary sidebar panels (settings, organization)
 * rendered from `OtherSidebarPanels`. Both are cmdk `Command` lists, so both
 * need the same `data-[selected=true]` neutralisation — keeping the recipe here
 * stops one panel from silently missing a fix the other shipped.
 */
export function getPanelNavItemClasses(isSelected: boolean, extraClasses?: string) {
  return cn(
    buttonVariants({
      variant: 'ghost',
      size: 'sm',
      disableAutomaticTypographyClasses: true,
    }),
    // Long translated labels must wrap in the narrow panel. `whitespace-normal`
    // (not `text-wrap`) so tailwind-merge drops `buttonVariants`'
    // `whitespace-nowrap`; `text-start` stops the second line centring.
    'h-fit w-full justify-start whitespace-normal text-start',
    'text-text-secondary',
    'hover:bg-background-tertiary hover:text-text-primary',
    // The DS `CommandItem` paints primary on `data-[selected=true]`, and cmdk
    // leaves that sticky after mouse-out — repaint it back to resting…
    'data-[selected=true]:bg-transparent data-[selected=true]:text-text-secondary',
    // …then restore the hover look on real hover only. The two-variant
    // selector out-specifies the single-variant rule above.
    'data-[selected=true]:hover:bg-background-tertiary data-[selected=true]:hover:text-text-primary',
    isSelected && [
      // Matches the chat history sidebar's selected state (`panel_ghost`
      // variant) — softer than the main app sidebar's `secondary-pressed` but
      // still reads as "active".
      'bg-background-secondary text-text-primary',
      // Pin both hover rules to the idle fill so the active row offers no
      // hover affordance — clicking it is a no-op.
      'hover:bg-background-secondary',
      'data-[selected=true]:bg-background-secondary data-[selected=true]:text-text-primary data-[selected=true]:hover:bg-background-secondary',
    ],
    extraClasses
  );
}
